import { useEffect, useState } from "react";
import { CheckCircle2, FileKey2, LockKeyhole, ShieldAlert, UploadCloud } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { api } from "../../axios/api";
import { notify } from "../../utils/toastAlert";
import { setCachedLicenseStatus, clearCachedLicenseStatus } from "../../utils/licenseCache";
const companyId=()=>{try{const e=JSON.parse(localStorage.getItem('empresa')||'null'),u=JSON.parse(localStorage.getItem('user')||'null');return Number(e?.id||u?.empresa_id)||null}catch{return null}};

const LicenseExpired = () => {
  const navigate = useNavigate();
  const [unlocked,setUnlocked]=useState(false);
  const [licenseFile, setLicenseFile] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedName,setSelectedName]=useState("");
  useEffect(()=>{if(unlocked)return;const code='eloise231';let typed='';let timer;const capture=e=>{if(e.ctrlKey||e.altKey||e.metaKey||e.key.length!==1)return;typed=`${typed}${e.key.toLowerCase()}`.slice(-code.length);clearTimeout(timer);timer=setTimeout(()=>typed='',2500);if(typed===code){clearTimeout(timer);setUnlocked(true)}};window.addEventListener('keydown',capture);return()=>{clearTimeout(timer);window.removeEventListener('keydown',capture)}},[unlocked]);

  const handleFile = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setLicenseFile(await file.text());
    setSelectedName(file.name);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setErrorMessage("");

    try {
      const empresaId=companyId();
      const imported = await api.post("/licensas/importar", { license_file: licenseFile, empresa_id: empresaId });
      const activatedEmpresaId = Number(imported.data?.data?.empresa_id || empresaId) || null;
      const status = await api.get("/licensas/status", { params: { empresa_id: activatedEmpresaId } });
      setCachedLicenseStatus(status.data || {});
      await notify("Licença activada com sucesso.", "success");
      navigate("/dashboard/main", { replace: true });
      window.location.reload();
    } catch (error) {
      const message = error.response?.data?.error || error.message || "Não foi possível activar a licença.";
      clearCachedLicenseStatus();
      setErrorMessage(message);
      await notify(message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="license-expired-page">
      <section className={`license-expired-panel ${unlocked?'is-unlocked':''}`}>
        <div className="license-brand"><span>F</span><strong>Facturize</strong></div><div className="license-expired-icon">{unlocked?<FileKey2 size={32}/>:<ShieldAlert size={32}/>}</div><span className="license-kicker">Segurança e licenciamento</span><h1>{unlocked?'Activar licença':'Licença indisponível'}</h1><p>{unlocked?'Seleccione o ficheiro de licença emitido para esta empresa e módulo.':'O acesso está temporariamente bloqueado. Contacte a administração Facturize para renovar ou instalar a licença.'}</p>{!unlocked&&<div className="license-lock-note"><LockKeyhole size={17}/><span>A activação é protegida por código de acesso.</span></div>}
        {errorMessage && <div className="license-error">{errorMessage}</div>}
        {unlocked&&<form onSubmit={handleSubmit}><label className={`license-file-drop ${selectedName?'has-file':''}`}><input type="file" accept=".lic,.txt" onChange={handleFile}/>{selectedName?<CheckCircle2 size={24}/>:<UploadCloud size={26}/>}<strong>{selectedName||'Seleccionar ficheiro .lic'}</strong><small>{selectedName?'Ficheiro pronto para validação':'Clique para escolher a licença'}</small></label><details className="license-paste"><summary>Ou colar o conteúdo da licença</summary><textarea value={licenseFile} onChange={e=>setLicenseFile(e.target.value)} placeholder="Cole aqui o conteúdo do ficheiro de licença"/></details><button type="submit" disabled={loading||!licenseFile.trim()}>{loading?'A validar licença...':'Validar e activar'}</button></form>}<footer>© Facturize ERP · Licenciamento seguro</footer>
      </section>
    </main>
  );
};

export default LicenseExpired;
